module.exports = __webpack_public_path__ + "img/img_rank_01.64852488.svg";